export enum NumberSeparatorEnum {
  COMMA = 'COMMA',
  POINT = 'POINT',
  SPACE = 'SPACE'
}
